import React, { useState, useEffect } from "react";
import $ from 'jquery';
import 'jquery-ui/themes/base/all.css';
import 'jquery-ui/ui/widgets/datepicker';
import Select from "react-select";

import Sidebar from "../../component/Sidebar";
import Topbar from "../../component/Topbar";
import { FiPlus, FiTrash2, FiFileText, FiUser, FiPackage, FiDollarSign, FiCalendar, FiSettings, FiAlignLeft } from "react-icons/fi";

import { baseurl } from "../../baseurl";
import axios from "axios";

/* ─────────────────────────────── CSS ─────────────────────────────── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;600;700;800&family=DM+Sans:wght@400;500;600&display=swap');

:root {
  --q-teal:      #0a5556;
  --q-teal-mid:  #0c7172;
  --q-teal-lite: #14b8a6;
  --q-teal-faint:rgba(10,85,86,0.06);
  --q-gold:      #FFD166;
  --q-bg:        #eef6f6;
  --q-white:     #ffffff;
  --q-border:    rgba(10,85,86,0.10);
  --q-text:      #0f2a2a;
  --q-muted:     #5a8080;
  --q-danger:    #ef4444;
  --q-success:   #10b981;
  --q-warning:   #f59e0b;
  --q-radius:    16px;
}

@keyframes q__fadeUp  { from{opacity:0;transform:translateY(16px)} to{opacity:1;transform:translateY(0)} }
@keyframes q__shimmer { 0%{background-position:-600px 0} 100%{background-position:600px 0} }
@keyframes q__pulse   { 0%,100%{box-shadow:0 0 0 0 rgba(10,85,86,0.35)} 70%{box-shadow:0 0 0 8px rgba(10,85,86,0)} }

/* ── page wrapper ── */
.q__wrap {
  font-family: 'DM Sans', sans-serif;
  padding: 22px 22px 40px;
  background: var(--q-bg);
  min-height: 100vh;
  animation: q__fadeUp 0.4s ease both;
}

/* ── page header ── */
.q__hd { display:flex; align-items:flex-start; justify-content:space-between; gap:16px; margin-bottom:24px; flex-wrap:wrap; }
.q__hd-left { display:flex; align-items:center; gap:14px; }
.q__hd-icon {
  width:48px; height:48px; border-radius:14px; flex-shrink:0;
  background:linear-gradient(135deg,var(--q-teal),var(--q-teal-lite));
  display:flex; align-items:center; justify-content:center;
  font-size:20px; color:#fff;
  box-shadow:0 6px 18px rgba(10,85,86,0.26);
}
.q__hd-title { font-family:'Sora',sans-serif; font-size:20px; font-weight:800; color:var(--q-text); letter-spacing:-0.03em; margin:0 0 3px; }
.q__hd-sub   { font-size:12.5px; color:var(--q-muted); margin:0; }

/* ── section card ── */
.q__card {
  background:var(--q-white); border-radius:20px;
  border:1px solid var(--q-border);
  box-shadow:0 2px 20px rgba(10,85,86,0.07),0 8px 40px rgba(0,0,0,0.03);
  margin-bottom:20px; overflow:hidden; position:relative;
  animation:q__fadeUp 0.45s ease both;
}
.q__card::before {
  content:''; position:absolute; top:0; left:0; right:0; height:3px;
  background:linear-gradient(90deg,var(--q-teal) 0%,var(--q-teal-lite) 55%,var(--q-gold) 100%);
}

/* section header */
.q__sec-hd {
  display:flex; align-items:center; gap:10px;
  padding:18px 22px 14px;
  border-bottom:1px solid var(--q-border);
}
.q__sec-icon {
  width:34px; height:34px; border-radius:10px; flex-shrink:0;
  background:linear-gradient(135deg,var(--q-teal),var(--q-teal-lite));
  display:flex; align-items:center; justify-content:center;
  font-size:15px; color:#fff;
  box-shadow:0 4px 10px rgba(10,85,86,0.22);
}
.q__sec-title { font-family:'Sora',sans-serif; font-size:13.5px; font-weight:700; color:var(--q-text); letter-spacing:-0.01em; }
.q__sec-sub   { font-size:11.5px; color:var(--q-muted); margin-left:auto; }

/* card body padding */
.q__body   { padding:20px 22px; }
.q__body-lg{ padding:20px 22px 6px; }

/* ── label ── */
.q__lbl {
  display:flex; align-items:center; gap:6px;
  font-size:10.5px; font-weight:700; color:var(--q-text);
  margin-bottom:6px; letter-spacing:0.06em; text-transform:uppercase;
}
.q__lbl-dot { width:5px; height:5px; border-radius:50%; background:var(--q-teal); flex-shrink:0; }

/* ── input / select / textarea ── */
.q__input, .q__select, .q__textarea {
  width:100%; padding:10px 13px;
  font-size:13px; font-family:'DM Sans',sans-serif; color:var(--q-text);
  background:#f3fafa; border:1.5px solid #c8e4e4; border-radius:11px;
  outline:none; box-sizing:border-box;
  transition:border-color 0.18s, box-shadow 0.18s, background 0.18s;
}
.q__input:focus,.q__select:focus,.q__textarea:focus {
  border-color:var(--q-teal); background:#fff;
  box-shadow:0 0 0 4px rgba(10,85,86,0.09);
}
.q__input::placeholder,.q__textarea::placeholder { color:#9ababa; }
.q__input[readonly] { background:rgba(10,85,86,0.04); color:var(--q-muted); cursor:default; }
.q__select {
  appearance:none;
  background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%235a8080' stroke-width='2.5'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
  background-repeat:no-repeat; background-position:right 12px center;
  padding-right:32px;
}
.q__textarea { resize:vertical; min-height:90px; }

/* input with icon */
.q__field-wrap { position:relative; }
.q__field-icon {
  position:absolute; left:11px; top:50%; transform:translateY(-50%);
  color:#7aadad; font-size:14px; pointer-events:none;
}
.q__input--icon { padding-left:33px; }

/* ── grid helpers ── */
.q__grid2 { display:grid; grid-template-columns:1fr 1fr; gap:14px; }
.q__grid3 { display:grid; grid-template-columns:1fr 1fr 1fr; gap:14px; }
.q__grid4 { display:grid; grid-template-columns:1fr 1fr 1fr 1fr; gap:14px; }
.q__field  { /* field wrapper */ }

/* ── quotation number chip ── */
.q__num-chip {
  display:inline-flex; align-items:center; gap:8px;
  background:rgba(10,85,86,0.07); border:1px solid rgba(10,85,86,0.15);
  border-radius:10px; padding:9px 14px;
  font-family:'Sora',sans-serif; font-size:13px; font-weight:700;
  color:var(--q-teal); letter-spacing:0.03em; width:100%;
}
.q__num-chip-label { font-size:9px; text-transform:uppercase; letter-spacing:0.1em; color:var(--q-muted); font-weight:600; }

/* ── toggle group ── */
.q__toggle-group { display:flex; gap:4px; }
.q__toggle-btn {
  flex:1; padding:9px 10px; border-radius:10px;
  font-size:12px; font-family:'Sora',sans-serif; font-weight:700;
  border:1.5px solid rgba(10,85,86,0.18); background:var(--q-bg);
  color:var(--q-muted); cursor:pointer; text-align:center;
  transition:all 0.18s; letter-spacing:0.02em;
}
.q__toggle-btn:hover { border-color:var(--q-teal); color:var(--q-teal); background:rgba(10,85,86,0.05); }
.q__toggle-btn--active {
  background:linear-gradient(135deg,var(--q-teal),var(--q-teal-lite)) !important;
  border-color:transparent !important; color:#fff !important;
  box-shadow:0 4px 12px rgba(10,85,86,0.26);
}
/* status buttons */
.q__status-pending  { --sc:#f59e0b; --sb:rgba(245,158,11,0.12); }
.q__status-accepted { --sc:#10b981; --sb:rgba(16,185,129,0.12); }
.q__status-rejected { --sc:#ef4444; --sb:rgba(239,68,68,0.10); }
.q__toggle-btn--status { border-color:rgba(90,128,128,0.18) !important; }
.q__toggle-btn--status-active {
  background:var(--sb) !important;
  border:1.5px solid var(--sc) !important;
  color:var(--sc) !important;
  box-shadow:none !important;
}

/* ── billing divider ── */
.q__billing-grid {
  display:grid; grid-template-columns:1fr 1px 1fr; gap:0;
}
.q__billing-sep { background:var(--q-border); margin:0 20px; }
.q__billing-col { padding:20px 22px; }
.q__billing-hd  { display:flex; align-items:center; gap:8px; margin-bottom:14px; }
.q__billing-hd-icon {
  width:28px; height:28px; border-radius:8px; flex-shrink:0;
  display:flex; align-items:center; justify-content:center; font-size:13px;
}
.q__billing-hd-icon--seller   { background:rgba(10,85,86,0.10); color:var(--q-teal); }
.q__billing-hd-icon--customer { background:rgba(20,184,166,0.12); color:var(--q-teal-lite); }
.q__billing-hd-title { font-family:'Sora',sans-serif; font-size:12.5px; font-weight:700; color:var(--q-text); }
.q__billing-hd-sub   { font-size:11px; color:var(--q-muted); margin-left:auto; }

/* ── items table ── */
.q__table-wrap { overflow-x:auto; }
.q__table {
  width:100%; border-collapse:collapse; min-width:600px;
}
.q__table thead th {
  font-family:'Sora',sans-serif; font-size:10px; font-weight:700;
  letter-spacing:0.09em; text-transform:uppercase; color:var(--q-teal);
  background:rgba(10,85,86,0.04); padding:10px 12px;
  white-space:nowrap; border-bottom:1px solid var(--q-border);
}
.q__table tbody tr { border-bottom:1px solid rgba(10,85,86,0.05); }
.q__table tbody tr:last-child { border-bottom:none; }
.q__table tbody tr:hover { background:rgba(10,85,86,0.02); }
.q__table tbody td { padding:9px 12px; vertical-align:middle; }

/* small table inputs */
.q__table-input, .q__table-select {
  width:100%; padding:7px 10px;
  font-size:12.5px; font-family:'DM Sans',sans-serif; color:var(--q-text);
  background:#f3fafa; border:1.5px solid #c8e4e4; border-radius:9px;
  outline:none; box-sizing:border-box;
  transition:border-color 0.16s, box-shadow 0.16s;
}
.q__table-input:focus,.q__table-select:focus {
  border-color:var(--q-teal); background:#fff;
  box-shadow:0 0 0 3px rgba(10,85,86,0.09);
}
.q__table-select {
  appearance:none;
  background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 24 24' fill='none' stroke='%235a8080' stroke-width='2.5'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
  background-repeat:no-repeat; background-position:right 8px center;
  padding-right:24px;
}
.q__amount-cell {
  font-family:'Sora',sans-serif; font-size:13px; font-weight:700;
  color:var(--q-teal); text-align:right;
}
.q__del-btn {
  width:30px; height:30px; border-radius:8px; border:none;
  background:transparent; cursor:pointer; color:var(--q-muted);
  display:flex; align-items:center; justify-content:center; font-size:14px;
  transition:background 0.15s, color 0.15s;
}
.q__del-btn:hover { background:rgba(239,68,68,0.09); color:var(--q-danger); }

/* add item button */
.q__add-item-btn {
  display:inline-flex; align-items:center; gap:7px;
  padding:8px 16px; border-radius:10px;
  font-size:12.5px; font-family:'Sora',sans-serif; font-weight:700;
  color:var(--q-teal); background:rgba(10,85,86,0.07);
  border:1.5px dashed rgba(10,85,86,0.28); cursor:pointer;
  transition:background 0.16s, border-color 0.16s;
  margin:12px 22px 16px;
}
.q__add-item-btn:hover { background:rgba(10,85,86,0.11); border-color:var(--q-teal); }

/* ── bottom row ── */
.q__bottom { display:grid; grid-template-columns:1fr 1fr; gap:20px; margin-top:0; }

/* notes card */
.q__notes-card { height:100%; }

/* summary card */
.q__summary {
  background:var(--q-white); border-radius:20px;
  border:1px solid var(--q-border);
  box-shadow:0 2px 20px rgba(10,85,86,0.07);
  overflow:hidden; position:relative;
}
.q__summary::before {
  content:''; position:absolute; top:0; left:0; right:0; height:3px;
  background:linear-gradient(90deg,var(--q-teal),var(--q-teal-lite),var(--q-gold));
}
.q__summary-hd {
  display:flex; align-items:center; gap:10px;
  padding:16px 20px 12px; border-bottom:1px solid var(--q-border);
}
.q__summary-body { padding:16px 20px; display:flex; flex-direction:column; gap:7px; }
.q__sum-row { display:flex; align-items:center; justify-content:space-between; font-size:13px; }
.q__sum-row-lbl { color:var(--q-muted); }
.q__sum-row-val { font-weight:600; color:var(--q-text); }
.q__sum-sep { height:1px; background:var(--q-border); margin:4px 0; }
.q__sum-total {
  display:flex; align-items:center; justify-content:space-between;
  padding:14px 20px; margin-top:2px;
  background:linear-gradient(135deg,var(--q-teal),var(--q-teal-mid));
  border-radius:0 0 20px 20px;
}
.q__sum-total-lbl { font-family:'Sora',sans-serif; font-size:12px; font-weight:700; color:rgba(255,255,255,0.75); text-transform:uppercase; letter-spacing:0.06em; }
.q__sum-total-val { font-family:'Sora',sans-serif; font-size:22px; font-weight:800; color:#fff; letter-spacing:-0.02em; }

/* ── submit button ── */
.q__submit-btn {
  width:100%; padding:14px;
  font-size:15px; font-family:'Sora',sans-serif; font-weight:700;
  color:#fff; letter-spacing:0.04em;
  background:linear-gradient(135deg,var(--q-teal) 0%,var(--q-teal-mid) 50%,var(--q-teal-lite) 100%);
  background-size:200% auto;
  border:none; border-radius:13px; cursor:pointer;
  box-shadow:0 6px 24px rgba(10,85,86,0.34);
  transition:background-position 0.4s, transform 0.14s, box-shadow 0.18s;
  position:relative; overflow:hidden;
  display:flex; align-items:center; justify-content:center; gap:8px;
  margin-top:14px;
}
.q__submit-btn::after {
  content:''; position:absolute; inset:0;
  background:linear-gradient(90deg,transparent,rgba(255,255,255,0.12),transparent);
  background-size:400px 100%; opacity:0; transition:opacity 0.3s;
}
.q__submit-btn:hover { background-position:right center; transform:translateY(-1px); box-shadow:0 10px 30px rgba(10,85,86,0.40); }
.q__submit-btn:hover::after { opacity:1; animation:q__shimmer 1.1s linear infinite; }
.q__submit-btn:active { transform:translateY(0); }

/* ── gst type indicator ── */
.q__gst-badge {
  display:inline-flex; align-items:center; gap:5px;
  font-size:10.5px; font-weight:700; font-family:'Sora',sans-serif;
  border-radius:50px; padding:3px 10px; letter-spacing:0.05em;
}
.q__gst-badge--igst   { background:rgba(59,130,246,0.09); color:#2563eb; border:1px solid rgba(59,130,246,0.18); }
.q__gst-badge--cgst   { background:rgba(10,85,86,0.08);   color:var(--q-teal); border:1px solid rgba(10,85,86,0.16); }

/* ── PRODUCT CATALOG TOGGLE BAR ── */
.q__product-toggle-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 22px;
  background: rgba(10,85,86,0.03);
  border-bottom: 1px solid var(--q-border);
}
.q__product-toggle-left {
  display: flex;
  align-items: center;
  gap: 9px;
}
.q__product-toggle-label {
  font-family: 'Sora', sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: var(--q-teal);
  letter-spacing: .03em;
}
.q__product-toggle-sub {
  font-size: 10.5px;
  color: var(--q-muted);
  margin-top: 1px;
}
/* iOS pill switch */
.q__pill-switch {
  position: relative;
  width: 40px;
  height: 22px;
  flex-shrink: 0;
}
.q__pill-switch input { opacity:0; width:0; height:0; position:absolute; }
.q__pill-slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background: #c8e4e4;
  border-radius: 50px;
  transition: background .25s;
}
.q__pill-slider::before {
  content: '';
  position: absolute;
  height: 16px; width: 16px;
  left: 3px; top: 3px;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 1px 4px rgba(0,0,0,.18);
  transition: transform .25s;
}
.q__pill-switch input:checked + .q__pill-slider { background: linear-gradient(135deg, var(--q-teal), var(--q-teal-lite)); }
.q__pill-switch input:checked + .q__pill-slider::before { transform: translateX(18px); }

/* react-select overrides to match design system */
.q-rs__control {
  background: #f3fafa !important;
  border: 1.5px solid #c8e4e4 !important;
  border-radius: 9px !important;
  min-height: 34px !important;
  box-shadow: none !important;
  font-family: 'DM Sans', sans-serif !important;
  font-size: 12.5px !important;
  transition: border-color .18s, box-shadow .18s !important;
}
.q-rs__control--is-focused {
  border-color: var(--q-teal) !important;
  background: #fff !important;
  box-shadow: 0 0 0 3px rgba(10,85,86,.09) !important;
}
.q-rs__placeholder { color: #9ababa !important; font-size: 12.5px !important; }
.q-rs__single-value { color: var(--q-text) !important; font-size: 12.5px !important; }
.q-rs__input-container { color: var(--q-text) !important; font-size: 12.5px !important; }
.q-rs__menu {
  border-radius: 12px !important;
  border: 1.5px solid #c8e4e4 !important;
  box-shadow: 0 8px 28px rgba(10,85,86,.14) !important;
  overflow: hidden !important;
  font-family: 'DM Sans', sans-serif !important;
  z-index: 9999 !important;
}
.q-rs__option {
  font-size: 12.5px !important;
  padding: 9px 14px !important;
  cursor: pointer !important;
}
.q-rs__option--is-focused { background: rgba(10,85,86,.06) !important; color: var(--q-text) !important; }
.q-rs__option--is-selected { background: linear-gradient(135deg, var(--q-teal), var(--q-teal-lite)) !important; color: #fff !important; }
.q-rs__indicator-separator { background-color: #c8e4e4 !important; }
.q-rs__dropdown-indicator { color: var(--q-teal) !important; padding: 0 8px !important; }
.q-rs__clear-indicator { color: var(--q-muted) !important; }
.q-rs__value-container { padding: 2px 10px !important; }

/* product option renderer */
.q-opt__badge {
  display: inline-block;
  padding: 1px 7px;
  border-radius: 50px;
  font-size: 9.5px;
  font-weight: 700;
  font-family: 'Sora', sans-serif;
  margin-left: 6px;
  vertical-align: middle;
}
.q-opt__badge--service { background: rgba(20,184,166,.15); color: #0c7172; }
.q-opt__badge--product { background: rgba(255,209,102,.22); color: #8a6000; }
.q-opt__meta { font-size: 10.5px; color: var(--q-muted); margin-top: 1px; }
.q-opt__row { display: flex; align-items: center; justify-content: space-between; }
.q-opt__rate { font-family: 'Sora', sans-serif; font-weight: 700; font-size: 11px; color: var(--q-teal); }

/* responsive */
@media(max-width:900px){
  .q__billing-grid { grid-template-columns:1fr; }
  .q__billing-sep  { display:none; }
  .q__bottom       { grid-template-columns:1fr; }
  .q__grid4        { grid-template-columns:1fr 1fr; }
}
@media(max-width:600px){
  .q__grid2,.q__grid3,.q__grid4 { grid-template-columns:1fr; }
}
`;

/* ─────────────────────── HELPERS ─────────────────────── */
const GST_SLABS = [0, 5, 12, 18, 28];

const splitGST = (totalTax, gstType) => {
  if (gstType === "IGST") return { IGST: totalTax, CGST: 0, SGST: 0 };
  return { IGST: 0, CGST: totalTax / 2, SGST: totalTax / 2 };
};

const fmt = (n) => `₹ ${Number(n || 0).toFixed(2)}`;

/* ── Custom Option renderer for React Select ── */
const ProductOption = ({ innerRef, innerProps, data, isSelected }) => (
  <div
    ref={innerRef}
    {...innerProps}
    style={{
      padding: "9px 14px",
      cursor: "pointer",
      background: isSelected
        ? "linear-gradient(135deg, #0a5556, #14b8a6)"
        : "transparent",
      color: isSelected ? "#fff" : "#0f2a2a",
    }}
  >
    <div className="q-opt__row">
      <span style={{ fontWeight: 600, fontSize: 12.5 }}>
        {data.label}
        <span
          className={`q-opt__badge ${data.type === "Service" ? "q-opt__badge--service" : "q-opt__badge--product"}`}
          style={isSelected ? { background: "rgba(255,255,255,.22)", color: "#fff" } : {}}
        >
          {data.type}
        </span>
      </span>
      <span className="q-opt__rate" style={isSelected ? { color: "rgba(255,255,255,.85)" } : {}}>
        ₹{data.rate}
      </span>
    </div>
    <div className="q-opt__meta" style={isSelected ? { color: "rgba(255,255,255,.65)" } : {}}>
      HSN/SAC: {data.hsn || "—"} · GST {data.tax}%
    </div>
  </div>
);

/* ─────────────────────── COMPONENT ─────────────────────── */
function CreateQuotation() {
  const getDefaultDate = (daysOffset = 0) => {
    const date = new Date();
    date.setDate(date.getDate() + daysOffset);
    return date.toISOString().split("T")[0];
  };

  const token = localStorage.getItem("auth_token");

  // ── Product Catalog State ──
  const [productOptions, setProductOptions] = useState([]);
  const [useProductDropdown, setUseProductDropdown] = useState(false);

  const [quotation, setQuotation] = useState({
    quotationNumber: "",
    quotationDate: getDefaultDate(0),
    validityDate: getDefaultDate(30),
    status: "Pending",
    customer: { name: "", email: "", phone: "", address: "", gstin: "", state: "" },
    seller: { name: "", gstin: "", state: "", phone: "" },
    items: [{ description: "", hsn: "", qty: 1, rate: 0, tax: 18 }],
    discount: 0,
    additionalCharges: 0,
    gstInclusive: false,
    notes: "This quotation is valid for 30 days from the date of issue.",
  });

  /* fetch business info (unchanged) */
  useEffect(() => {
    const fetchBusinessInfo = async () => {
      try {
        const res = await axios.get(`${baseurl}getBusinessInfo`, {
          headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        });
        if (res.data.success && res.data.data) {
          const b = res.data.data;
          setQuotation((prev) => ({
            ...prev,
            seller: { name: b.business_name || "", gstin: b.gst || "", state: b.state || "", phone: b.whatsapp_number || "" },
          }));
        }
      } catch (err) { console.error("Error fetching business info:", err); }
    };
    fetchBusinessInfo();
  }, []);

  /* ── Fetch Product Catalog ── */
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axios.get(`${baseurl}getAllProducts`, {
          headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        });
        if (res.data.success && res.data.data) {
          const options = res.data.data.map((p) => ({
            value: p.id,
            label: p.product_data?.name || `Product #${p.id}`,
            description: p.product_data?.name || "",
            hsn: p.product_data?.hsn_sac || "",
            rate: p.product_data?.rate ?? 0,
            tax: p.product_data?.tax_percent ?? 18,
            type: p.type || "Product",
            unit: p.product_data?.unit || "",
          }));
          setProductOptions(options);
        }
      } catch (err) {
        console.error("Error fetching products:", err);
      }
    };
    fetchProducts();
  }, []);

  const [applyGSTItemWise, setApplyGSTItemWise]       = useState(true);
  const [quotationGSTPercent, setQuotationGSTPercent] = useState(18);

  const updateQuotationMeta = (fieldName, value) => setQuotation(prev => ({ ...prev, [fieldName]: value }));
  const handleQuotationStatusChange = (status) => setQuotation(prev => ({ ...prev, status }));

  /* jQuery datepicker (unchanged) */
  useEffect(() => {
    const $qDate = $('#quotationDateInput');
    const $vDate = $('#validityDateInput');
    const handleDateSelect = (dateText, inst) => {
      const fieldName = inst.id === 'quotationDateInput' ? 'quotationDate' : 'validityDate';
      updateQuotationMeta(fieldName, dateText);
    };
    $qDate.datepicker({ dateFormat: "yy-mm-dd", onSelect: handleDateSelect, defaultDate: quotation.quotationDate });
    $vDate.datepicker({ dateFormat: "yy-mm-dd", onSelect: handleDateSelect, defaultDate: quotation.validityDate });
    return () => { $qDate.datepicker('destroy'); $vDate.datepicker('destroy'); };
  }, []);

  useEffect(() => {
    $('#quotationDateInput').datepicker('setDate', quotation.quotationDate);
    $('#validityDateInput').datepicker('setDate', quotation.validityDate);
  }, [quotation.quotationDate, quotation.validityDate]);

  /* item handlers (unchanged) */
  const addItem    = () => setQuotation(prev => ({ ...prev, items: [...prev.items, { description: "", hsn: "", qty: 1, rate: 0, tax: 0 }] }));
  const removeItem = (index) => setQuotation(prev => ({ ...prev, items: prev.items.filter((_, i) => i !== index) }));
  const updateItem = (index, field, value) => {
    const items = [...quotation.items];
    items[index][field] = value;
    setQuotation({ ...quotation, items });
  };
  const updateCustomer = (field, value) => setQuotation(prev => ({ ...prev, customer: { ...prev.customer, [field]: value } }));
  const updateSeller   = (field, value) => setQuotation(prev => ({ ...prev, seller:   { ...prev.seller,   [field]: value } }));

  /* ── Handle product selection from dropdown ── */
  const handleProductSelect = (index, selectedOption) => {
    if (!selectedOption) {
      const items = [...quotation.items];
      items[index] = { ...items[index], description: "", hsn: "", rate: 0, tax: 18 };
      setQuotation({ ...quotation, items });
      return;
    }
    const items = [...quotation.items];
    items[index] = {
      ...items[index],
      description: selectedOption.description,
      hsn: selectedOption.hsn,
      rate: selectedOption.rate,
      tax: selectedOption.tax,
      // qty intentionally preserved
    };
    setQuotation({ ...quotation, items });
  };

  // Find which option matches current row
  const getSelectedProductOption = (item) => {
    if (!item.description) return null;
    return productOptions.find(
      (o) => o.description === item.description && o.rate === item.rate
    ) || null;
  };

  /* calculations (unchanged) */
  const { items, discount, additionalCharges, gstInclusive, customer, seller } = quotation;
  const itemSubtotal   = items.reduce((acc, item) => acc + item.qty * item.rate, 0);
  const discountAmount = (itemSubtotal * discount) / 100;
  const taxableAmount  = itemSubtotal - discountAmount + Number(additionalCharges);

  const calculateTotalTax = () => {
    if (applyGSTItemWise) {
      return items.reduce((acc, item) => {
        const itemAmount = item.qty * item.rate;
        return gstInclusive
          ? acc + (itemAmount * item.tax) / (100 + item.tax)
          : acc + (itemAmount * item.tax) / 100;
      }, 0);
    } else {
      return gstInclusive
        ? (taxableAmount * quotationGSTPercent) / (100 + quotationGSTPercent)
        : (taxableAmount * quotationGSTPercent) / 100;
    }
  };
  const totalTax    = calculateTotalTax();
  // const isInterState = customer.state.trim().toLowerCase() !== seller.state.trim().toLowerCase();

  const isInterState =
  !!(customer?.state?.trim()) &&
  !!(seller?.state?.trim()) &&
  customer.state.trim().toLowerCase() !== seller.state.trim().toLowerCase();


  const gstType     = isInterState ? "IGST" : "CGST_SGST";
  const { IGST, CGST, SGST } = splitGST(totalTax, gstType);
  const grandTotal  = gstInclusive ? taxableAmount : taxableAmount + totalTax;

  const getItemAmountDisplay = (item, isItemWise) => {
    const taxRate    = isItemWise ? item.tax : quotationGSTPercent;
    const grossAmount = item.qty * item.rate;
    return gstInclusive ? grossAmount.toFixed(2) : (grossAmount + (grossAmount * taxRate) / 100).toFixed(2);
  };

  /* submit (unchanged) */
  const handleSubmit = async (e) => {
    e.preventDefault();
    const dataToSend = {
      ...quotation,
      discount: Number(quotation.discount),
      additionalCharges: Number(quotation.additionalCharges),
      itemSubtotal, taxableAmount, totalTax, grandTotal,
      gstBreakdown: { IGST, CGST, SGST, gstType, isInterState },
    };
    console.log("🚀 Submitting Quotation Data:", dataToSend);
    try {
      const response = await axios.post(`${baseurl}saveQuotation`, dataToSend, {
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      });
      if (response.data.success) alert("Quotation created successfully!");
    } catch (err) {
      console.error("Submission Error:", err);
      alert(err.response?.data?.message || "Failed to submit quotation. Check console for details.");
    }
  };

  /* status colors */
  const statusMeta = {
    Pending:  { bg: "rgba(245,158,11,0.09)",  border: "#f59e0b", color: "#b45309" },
    Accepted: { bg: "rgba(16,185,129,0.09)",  border: "#10b981", color: "#047857" },
    Rejected: { bg: "rgba(239,68,68,0.08)",   border: "#ef4444", color: "#dc2626" },
  };

  /* ═══ RENDER ═══ */
  return (
    <>
      <style>{CSS}</style>
      <Topbar />
      <Sidebar />
      <main className="main-wrapper">
        <form onSubmit={handleSubmit}>
          <div className="q__wrap">

            {/* ── Page Header ── */}
            <div className="q__hd">
              <div className="q__hd-left">
                <div className="q__hd-icon"><FiFileText /></div>
                <div>
                  <div className="q__hd-title">Create GST Quotation</div>
                  <div className="q__hd-sub">Generate and manage price quotations for customers</div>
                </div>
              </div>
            </div>

            {/* ══ SECTION 1 — Quotation Details ══ */}
            <div className="q__card">
              <div className="q__sec-hd">
                <div className="q__sec-icon"><FiFileText size={15} /></div>
                <div className="q__sec-title">Quotation Details</div>
              </div>
              <div className="q__body">
                <div className="q__grid4">
                  {/* Number */}
                  <div className="q__field">
                    <div className="q__lbl"><div className="q__lbl-dot" />Quotation Number</div>
                    <div className="q__num-chip">
                      <span className="q__num-chip-label">QT#</span>
                      <span>{quotation.quotationNumber || "Auto-generated"}</span>
                    </div>
                    <input type="hidden" value={quotation.quotationNumber} onChange={(e) => updateQuotationMeta("quotationNumber", e.target.value)} readOnly />
                  </div>

                  {/* Date */}
                  <div className="q__field">
                    <div className="q__lbl"><div className="q__lbl-dot" />Quotation Date</div>
                    <div className="q__field-wrap">
                      <FiCalendar className="q__field-icon" />
                      <input type="text" id="quotationDateInput" className="q__input q__input--icon"
                        value={quotation.quotationDate}
                        onChange={(e) => updateQuotationMeta("quotationDate", e.target.value)} />
                    </div>
                  </div>

                  {/* Validity */}
                  <div className="q__field">
                    <div className="q__lbl"><div className="q__lbl-dot" />Valid Until</div>
                    <div className="q__field-wrap">
                      <FiCalendar className="q__field-icon" />
                      <input type="text" id="validityDateInput" className="q__input q__input--icon"
                        value={quotation.validityDate}
                        onChange={(e) => updateQuotationMeta("validityDate", e.target.value)} />
                    </div>
                  </div>

                  {/* Status */}
                  <div className="q__field">
                    <div className="q__lbl"><div className="q__lbl-dot" />Status</div>
                    <div className="q__toggle-group">
                      {["Pending", "Accepted", "Rejected"].map((s) => (
                        <button
                          key={s} type="button"
                          className={`q__toggle-btn q__toggle-btn--status ${quotation.status === s ? "q__toggle-btn--status-active" : ""}`}
                          style={quotation.status === s ? {
                            "--sc": statusMeta[s].color,
                            "--sb": statusMeta[s].bg,
                            borderColor: statusMeta[s].border,
                            background: statusMeta[s].bg,
                            color: statusMeta[s].color,
                          } : {}}
                          onClick={() => handleQuotationStatusChange(s)}
                          disabled={quotation.status === s && (s === "Accepted" || s === "Rejected")}
                        >
                          {s}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ══ SECTION 2 — GST Settings ══ */}
            <div className="q__card">
              <div className="q__sec-hd">
                <div className="q__sec-icon"><FiSettings size={15} /></div>
                <div className="q__sec-title">GST &amp; Tax Settings</div>
                <span className="q__sec-sub">
                  <span className={`q__gst-badge ${isInterState ? "q__gst-badge--igst" : "q__gst-badge--cgst"}`}>
                    {isInterState ? "IGST (Inter-state)" : "CGST + SGST (Intra-state)"}
                  </span>
                </span>
              </div>
              <div className="q__body">
                <div className="q__grid3">
                  {/* GST Mode */}
                  <div className="q__field">
                    <div className="q__lbl"><div className="q__lbl-dot" />GST Mode</div>
                    <div className="q__toggle-group">
                      <button type="button"
                        className={`q__toggle-btn ${!quotation.gstInclusive ? "q__toggle-btn--active" : ""}`}
                        onClick={() => setQuotation({ ...quotation, gstInclusive: false })}>
                        Exclusive
                      </button>
                      <button type="button"
                        className={`q__toggle-btn ${quotation.gstInclusive ? "q__toggle-btn--active" : ""}`}
                        onClick={() => setQuotation({ ...quotation, gstInclusive: true })}>
                        Inclusive
                      </button>
                    </div>
                  </div>

                  {/* Apply Tax By */}
                  <div className="q__field">
                    <div className="q__lbl"><div className="q__lbl-dot" />Apply Tax By</div>
                    <div className="q__toggle-group">
                      <button type="button"
                        className={`q__toggle-btn ${applyGSTItemWise ? "q__toggle-btn--active" : ""}`}
                        onClick={() => setApplyGSTItemWise(true)}>
                        Item-wise
                      </button>
                      <button type="button"
                        className={`q__toggle-btn ${!applyGSTItemWise ? "q__toggle-btn--active" : ""}`}
                        onClick={() => setApplyGSTItemWise(false)}>
                        Quote-wise
                      </button>
                    </div>
                  </div>

                  {/* Quote GST % */}
                  {!applyGSTItemWise && (
                    <div className="q__field">
                      <div className="q__lbl"><div className="q__lbl-dot" />Quotation GST %</div>
                      <select className="q__select" value={quotationGSTPercent}
                        onChange={(e) => setQuotationGSTPercent(parseFloat(e.target.value))}>
                        {GST_SLABS.map((g) => <option key={g} value={g}>{g}%</option>)}
                      </select>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* ══ SECTION 3 — Billing Details ══ */}
            <div className="q__card">
              <div className="q__sec-hd">
                <div className="q__sec-icon"><FiUser size={15} /></div>
                <div className="q__sec-title">Billing Details</div>
              </div>
              <div className="q__billing-grid">

                {/* Seller */}
                <div className="q__billing-col">
                  <div className="q__billing-hd">
                    <div className="q__billing-hd-icon q__billing-hd-icon--seller"><FiUser /></div>
                    <span className="q__billing-hd-title">Seller (Your Company)</span>
                    <span className="q__billing-hd-sub">Auto-filled</span>
                  </div>
                  <div className="q__grid2" style={{ marginBottom: 12 }}>
                    <div className="q__field">
                      <div className="q__lbl"><div className="q__lbl-dot" />Business Name</div>
                      <input type="text" className="q__input" value={seller.name} onChange={(e) => updateSeller("name", e.target.value)} />
                    </div>
                    <div className="q__field">
                      <div className="q__lbl"><div className="q__lbl-dot" />Phone</div>
                      <input type="text" className="q__input" value={seller.phone} onChange={(e) => updateSeller("phone", e.target.value)} />
                    </div>
                  </div>
                  <div className="q__grid2">
                    <div className="q__field">
                      <div className="q__lbl"><div className="q__lbl-dot" />GSTIN <span style={{ fontSize:9, color:"#9ababa", background:"rgba(10,85,86,0.06)", border:"1px solid #c8e4e4", borderRadius:50, padding:"1px 6px", marginLeft:4, textTransform:"none", letterSpacing:0 }}>Optional</span></div>
                      <input type="text" className="q__input" value={seller.gstin} onChange={(e) => updateSeller("gstin", e.target.value)} />
                    </div>
                    <div className="q__field">
                      <div className="q__lbl"><div className="q__lbl-dot" />State</div>
                      <input type="text" className="q__input" value={seller.state} onChange={(e) => updateSeller("state", e.target.value)} />
                    </div>
                  </div>
                </div>

                <div className="q__billing-sep" />

                {/* Customer */}
                <div className="q__billing-col">
                  <div className="q__billing-hd">
                    <div className="q__billing-hd-icon q__billing-hd-icon--customer"><FiUser /></div>
                    <span className="q__billing-hd-title">Customer Details</span>
                  </div>
                  <div className="q__grid2" style={{ marginBottom: 12 }}>
                    <div className="q__field">
                      <div className="q__lbl"><div className="q__lbl-dot" />Customer Name</div>
                      <input type="text" className="q__input" placeholder="Full name" value={customer.name} onChange={(e) => updateCustomer("name", e.target.value)} />
                    </div>
                    <div className="q__field">
                      <div className="q__lbl"><div className="q__lbl-dot" />Phone</div>
                      <input type="text" className="q__input" placeholder="Phone number" value={customer.phone} onChange={(e) => updateCustomer("phone", e.target.value)} />
                    </div>
                  </div>
                  <div className="q__grid2" style={{ marginBottom: 12 }}>
                    <div className="q__field">
                      <div className="q__lbl"><div className="q__lbl-dot" />GSTIN <span style={{ fontSize:9, color:"#9ababa", background:"rgba(10,85,86,0.06)", border:"1px solid #c8e4e4", borderRadius:50, padding:"1px 6px", marginLeft:4, textTransform:"none", letterSpacing:0 }}>Optional</span></div>
                      <input type="text" className="q__input" placeholder="27AAPFU0939F1ZV" value={customer.gstin} onChange={(e) => updateCustomer("gstin", e.target.value)} />
                    </div>
                    <div className="q__field">
                      <div className="q__lbl"><div className="q__lbl-dot" />State</div>
                      <input type="text" className="q__input" placeholder="Maharashtra" value={customer.state} onChange={(e) => updateCustomer("state", e.target.value)} />
                    </div>
                  </div>
                  <div className="q__field">
                    <div className="q__lbl"><div className="q__lbl-dot" />Address</div>
                    <textarea className="q__textarea" style={{ minHeight:60 }} placeholder="Street, City, PIN" value={customer.address} onChange={(e) => updateCustomer("address", e.target.value)} rows="2" />
                  </div>
                </div>

              </div>
            </div>

            {/* ══ SECTION 4 — Items ══ */}
            <div className="q__card">
              <div className="q__sec-hd">
                <div className="q__sec-icon"><FiPackage size={15} /></div>
                <div className="q__sec-title">Quotation Items</div>
                <span className="q__sec-sub">{items.length} item{items.length !== 1 ? "s" : ""}</span>
              </div>

              {/* ── Product/Service Catalog Toggle Bar ── */}
              <div className="q__product-toggle-bar">
                <div className="q__product-toggle-left">
                  <FiPackage size={14} style={{ color: "var(--q-teal)" }} />
                  <div>
                    <div className="q__product-toggle-label">
                      Select from Product / Service Catalog
                    </div>
                    <div className="q__product-toggle-sub">
                      {useProductDropdown
                        ? `${productOptions.length} items available — search by name`
                        : "Enable to pick items from your saved catalog"}
                    </div>
                  </div>
                </div>
                <label className="q__pill-switch">
                  <input
                    type="checkbox"
                    checked={useProductDropdown}
                    onChange={(e) => setUseProductDropdown(e.target.checked)}
                  />
                  <span className="q__pill-slider" />
                </label>
              </div>

              <div className="q__table-wrap">
                <table className="q__table">
                  <thead>
                    <tr>
                      {useProductDropdown && <th style={{ width: "18%" }}>Product / Service</th>}
                      <th style={{ width: useProductDropdown ? "20%" : "34%" }}>Description</th>
                      <th style={{ width:"10%" }}>HSN / SAC</th>
                      <th style={{ width:"8%" }}>Qty</th>
                      <th style={{ width:"13%" }}>Rate ({gstInclusive ? "Incl." : "Excl."} Tax)</th>
                      {applyGSTItemWise && <th style={{ width:"10%" }}>Tax %</th>}
                      <th style={{ width:"13%", textAlign:"right" }}>Amount</th>
                      <th style={{ width:"7%", textAlign:"center" }}>Del</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((item, index) => (
                      <tr key={index}>

                        {/* ── Product Dropdown (only when toggle ON) ── */}
                        {useProductDropdown && (
                          <td style={{ minWidth: 170 }}>
                            <Select
                              classNamePrefix="q-rs"
                              options={productOptions}
                              value={getSelectedProductOption(item)}
                              onChange={(opt) => handleProductSelect(index, opt)}
                              placeholder="Search…"
                              isClearable
                              components={{ Option: ProductOption }}
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                control: (base) => ({ ...base, minHeight: 34 }),
                              }}
                            />
                          </td>
                        )}

                        <td>
                          <input type="text" className="q__table-input" placeholder="Item description…"
                            value={item.description} onChange={(e) => updateItem(index, "description", e.target.value)} />
                        </td>
                        <td>
                          <input type="text" className="q__table-input" placeholder="HSN"
                            value={item.hsn} onChange={(e) => updateItem(index, "hsn", e.target.value)} />
                        </td>
                        <td>
                          <input type="number" className="q__table-input" style={{ textAlign:"center" }}
                            value={item.qty} onChange={(e) => updateItem(index, "qty", parseFloat(e.target.value) || 0)} />
                        </td>
                        <td>
                          <input type="number" className="q__table-input"
                            value={item.rate} onChange={(e) => updateItem(index, "rate", parseFloat(e.target.value) || 0)} />
                        </td>
                        {applyGSTItemWise && (
                          <td>
                            <select className="q__table-select" value={item.tax}
                              onChange={(e) => updateItem(index, "tax", parseFloat(e.target.value))}>
                              {GST_SLABS.map((g) => <option key={g} value={g}>{g}%</option>)}
                            </select>
                          </td>
                        )}
                        <td>
                          <span className="q__amount-cell">₹ {getItemAmountDisplay(item, applyGSTItemWise)}</span>
                        </td>
                        <td style={{ textAlign:"center" }}>
                          <button type="button" className="q__del-btn" onClick={() => removeItem(index)} style={{ margin:"0 auto" }}>
                            <FiTrash2 size={13} />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <button type="button" className="q__add-item-btn" onClick={addItem}>
                <FiPlus size={13} /> Add Item
              </button>
            </div>

            {/* ══ BOTTOM — Notes + Summary ══ */}
            <div className="q__bottom">

              {/* Notes */}
              <div className="q__card q__notes-card" style={{ marginBottom: 0 }}>
                <div className="q__sec-hd">
                  <div className="q__sec-icon"><FiAlignLeft size={15} /></div>
                  <div className="q__sec-title">Notes &amp; Terms</div>
                </div>
                <div className="q__body">
                  <div className="q__field">
                    <div className="q__lbl"><div className="q__lbl-dot" />Quotation Notes</div>
                    <textarea className="q__textarea" rows="5"
                      placeholder="E.g., Payment Terms, Warranty, Validity period…"
                      value={quotation.notes}
                      onChange={(e) => updateQuotationMeta("notes", e.target.value)} />
                  </div>
                  <div className="q__grid2" style={{ marginTop: 14 }}>
                    <div className="q__field">
                      <div className="q__lbl"><div className="q__lbl-dot" />Discount %</div>
                      <input type="number" className="q__input" min="0" max="100" value={quotation.discount}
                        onChange={(e) => updateQuotationMeta("discount", e.target.value)} />
                    </div>
                    <div className="q__field">
                      <div className="q__lbl"><div className="q__lbl-dot" />Additional Charges (₹)</div>
                      <input type="number" className="q__input" value={quotation.additionalCharges}
                        onChange={(e) => updateQuotationMeta("additionalCharges", e.target.value)} />
                    </div>
                  </div>
                </div>
              </div>

              {/* Summary */}
              <div className="q__summary">
                <div className="q__summary-hd">
                  <div className="q__sec-icon"><FiDollarSign size={15} /></div>
                  <span className="q__sec-title">Quotation Summary</span>
                </div>
                <div className="q__summary-body">
                  <div className="q__sum-row">
                    <span className="q__sum-row-lbl">Subtotal</span>
                    <span className="q__sum-row-val">{fmt(itemSubtotal)}</span>
                  </div>
                  <div className="q__sum-row">
                    <span className="q__sum-row-lbl">Discount ({quotation.discount}%)</span>
                    <span className="q__sum-row-val" style={{ color:"#ef4444" }}>− {fmt(discountAmount)}</span>
                  </div>
                  {Number(quotation.additionalCharges) > 0 && (
                    <div className="q__sum-row">
                      <span className="q__sum-row-lbl">Additional Charges</span>
                      <span className="q__sum-row-val">+ {fmt(quotation.additionalCharges)}</span>
                    </div>
                  )}
                  <div className="q__sum-sep" />
                  <div className="q__sum-row">
                    <span className="q__sum-row-lbl">Taxable Amount</span>
                    <span className="q__sum-row-val">{fmt(taxableAmount)}</span>
                  </div>
                  {gstType === "IGST" ? (
                    <div className="q__sum-row">
                      <span className="q__sum-row-lbl">IGST</span>
                      <span className="q__sum-row-val">+ {fmt(IGST)}</span>
                    </div>
                  ) : (
                    <>
                      <div className="q__sum-row">
                        <span className="q__sum-row-lbl">CGST</span>
                        <span className="q__sum-row-val">+ {fmt(CGST)}</span>
                      </div>
                      <div className="q__sum-row">
                        <span className="q__sum-row-lbl">SGST</span>
                        <span className="q__sum-row-val">+ {fmt(SGST)}</span>
                      </div>
                    </>
                  )}
                </div>
                <div className="q__sum-total">
                  <span className="q__sum-total-lbl">Grand Total</span>
                  <span className="q__sum-total-val">₹ {grandTotal.toFixed(2)}</span>
                </div>
                <div style={{ padding: "0 20px 20px" }}>
                  <button type="submit" className="q__submit-btn">
                    <FiFileText size={16} /> Generate Quotation
                  </button>
                </div>
              </div>

            </div>

          </div>
        </form>
      </main>
    </>
  );
}

export default CreateQuotation;
